import React from 'react';
import SelectableCard, { SelectableCardContext, SelectableCardProps } from '../SelectableCard';
import { CollectionBreaker } from '../../Collection/model';

export function SelectableCardBreaker(props: SelectableCardProps<unknown>) {
  return (
    <SelectableCard {...props}>
      <SelectableCard.Image alt="Breaker" />
      <SelectableCard.Body>
        <SelectableCard.Title />
      </SelectableCard.Body>
    </SelectableCard>
  );
}

SelectableCardBreaker.transformer = (
  breaker: CollectionBreaker,
): SelectableCardContext<CollectionBreaker> => {
  return {
    ...breaker,
    title: `DuskBreaker #${breaker.id}`,
    image: breaker.image.thumbnail,
    ctx: breaker,
  };
};
